export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/real_estate_promos.4d4e9d1.svg";